import { DigitalIdDTO, StatesFieldsFrontDTO } from './../../model/requests-model';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import {
  CONTACT_DATA,
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_MG,
  FORM_MG_NO_SHOP,
  HOLDER_DATA,
  INTERVINIENTE_1_HOLDER_DATA,
  INTERVINIENTE_2_HOLDER_DATA,
  INTERVINIENTE_3_HOLDER_DATA,
  INTERVINIENTE_4_HOLDER_DATA,
  PENDIENTES_DE_DATOS,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_NEW,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CommonDataDTO, CountryDTO } from '@app/requests/model/combos-model';
import { Participant } from '@app/requests/model/requests-model';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { GeocodeStore } from '@app/requests/geocode-service/geocode.store';
import { RequestsGetDataStore } from '@app/requests/requests-get-data-service/requests-get-data.store';

const intervinientesHolderData: number[] = [
  INTERVINIENTE_1_HOLDER_DATA,
  INTERVINIENTE_2_HOLDER_DATA,
  INTERVINIENTE_3_HOLDER_DATA,
  INTERVINIENTE_4_HOLDER_DATA,
];

@UntilDestroy()
@Component({
  selector: 'scf-holder-data',
  templateUrl: './holder-data.component.html',
  styleUrls: ['./holder-data.component.scss'],
})
export class HolderDataComponent implements OnInit {
  @Input() public mode: string = 'new';
  @Input() public request: any = null;
  @Input() state: CommonDataDTO;
  @Input() public interviniente: Participant = null;
  @Input() public numInterviniente: string = '1';
  @Input('operative') set operative(data: any) {
    if (data) {
      const index = this.interviniente ? INTERVINIENTE_1_HOLDER_DATA : HOLDER_DATA;

      if (data === 'EIC' && this.requestStore.listaFormulariosConsumo.includes(this.holderDataForm)) {
        this.requestStore.listaFormulariosConsumo[index] = null;
      } else if (data !== 'EIC' && !this.requestStore.listaFormulariosConsumo.includes(this.holderDataForm)) {
        this.requestStore.setFormularioConsumo(this.holderDataForm, index);
      }
    }
  }
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public saveButtonCheck = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();
  @Output() public disabledOwnershipCombo = new EventEmitter<any>();

  public holderDataForm: FormGroup;

  countryList: CountryDTO[] = [];
  civilStatusList: CommonDataDTO[] = [];
  genderList: CommonDataDTO[] = [];
  relationHolderList: CommonDataDTO[] = [];
  holderAccountList: CommonDataDTO[] = [];

  //Loading
  private isGenderLoading: boolean = true;
  private isCivilStatusLoading: boolean = true;
  private isCountryLoading: boolean = true;
  private isRelationHolderLoading: boolean = true;
  private isDisableVSByEstablishment: boolean = false;

  maxDateBirthday: Date;
  minDateBirthday: Date = new Date('1/1/1900');
  minDateNif: Date;
  maxDateNif: Date = new Date('12/31/2099');
  showVideoSelfing: boolean = false;
  checked: boolean = false;
  touchVS: boolean = false;
  currentValueNoEmail: boolean = false;
  currentValueNoMovil: boolean = false;

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private combosStore: CombosStore,
    private customValidators: CustomValidatorsService,
    private translateService: TranslateService,
    private datepickerUtils: DatepickerUtilsService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private geocodeStore: GeocodeStore,
    private requestsGetDataStore: RequestsGetDataStore
  ) {
    const currentDate = new Date();
    this.maxDateBirthday = currentDate;
    this.minDateNif = currentDate;
  }

  ngOnInit(): void {
    this.holderDataForm = this.formBuilder.group({
      gender: ['', Validators.required],
      nifNie: ['', [Validators.required, this.customValidators.isNifNieValid]],
      nifNieExpiration: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.maxLength(30)]],
      surname1: ['', [Validators.required, Validators.maxLength(30)]],
      surname2: ['', [Validators.required, Validators.maxLength(30)]],
      birthDate: ['', [Validators.required, this.customValidators.isBirthdayValid]],
      nationality: ['', Validators.required],
      birthCountry: ['', Validators.required],
      civilStatus: ['', Validators.required],
    });

    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.holderDataForm, HOLDER_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.holderDataForm, HOLDER_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.holderDataForm, HOLDER_DATA);
    } else if (
      this.requestStore.getMarcaFormulario() === FORM_CONSUMO ||
      this.requestStore.getMarcaFormulario() === FORM_AUTO
    ) {
      let isConsumo = this.requestStore.getMarcaFormulario() === FORM_CONSUMO;

      if (this.interviniente) {
        this.holderDataForm.addControl('relationHolder', new FormControl('', Validators.required));
        this.holderDataForm.addControl('holderAccount', new FormControl('', Validators.required));
        this.holderAccountList = this.combosStore.holderAccountList;

        if (isConsumo) {
          this.holderDataForm.controls.holderAccount.setValue(this.combosStore.holderAccountList[1].id);
          this.holderDataForm.controls.holderAccount.disable();
        } else {
          this.validateAvalista();
        }

        switch (this.interviniente.id) {
          case 1:
            isConsumo
              ? this.requestStore.setFormularioConsumo(this.holderDataForm, INTERVINIENTE_1_HOLDER_DATA)
              : this.requestStore.setFormularioAutos(this.holderDataForm, INTERVINIENTE_1_HOLDER_DATA);
            break;
          case 2:
            this.requestStore.setFormularioAutos(this.holderDataForm, INTERVINIENTE_2_HOLDER_DATA);
            break;
          case 3:
            this.requestStore.setFormularioAutos(this.holderDataForm, INTERVINIENTE_3_HOLDER_DATA);
            break;
          case 4:
            this.requestStore.setFormularioAutos(this.holderDataForm, INTERVINIENTE_4_HOLDER_DATA);
            break;
          default:
            console.error('Interviniente Not found!');
        }
      } else {
        isConsumo
          ? this.requestStore.setFormularioConsumo(this.holderDataForm, HOLDER_DATA)
          : this.requestStore.setFormularioAutos(this.holderDataForm, HOLDER_DATA);
      }
    }

    this.holderDataForm.statusChanges.subscribe(() => {
      this.emitStatusForm();
    });

    this.holderDataForm.controls.nifNie.statusChanges.subscribe(() => {
      const isNIE = this.customValidators.isNie(this.holderDataForm.controls.nifNie?.value?.toUpperCase());
      isNIE
        ? this.holderDataForm.controls.surname2.clearValidators()
        : this.holderDataForm.controls.surname2.setValidators([Validators.required, Validators.maxLength(30)]);
      this.holderDataForm.controls.surname2.updateValueAndValidity({ onlySelf: true });
    });
    this.translateService.currentLang === 'es-ES' ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) => (event.lang === 'es-ES' ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()));

    //Load combos
    this.isGenderLoading = true;
    this.genderList = this.combosStore.genderList;
    if (this.genderList.length === 1) {
      this.holderDataForm.controls.gender.setValue(this.genderList[0].id);
    }
    this.isGenderLoading = false;

    this.isCivilStatusLoading = true;
    this.combosStore.civilStatusList$.subscribe((valor: CommonDataDTO[]) => {
      this.civilStatusList = valor;
      if (this.civilStatusList.length === 1) {
        this.holderDataForm.controls.civilStatus.setValue(this.civilStatusList[0].id);
      }
      this.isCivilStatusLoading = false;
      this.changeLoadingState();
    });

    this.isCountryLoading = true;
    this.combosStore.countryList$.subscribe((valor: CountryDTO[]) => {
      this.countryList = valor;
      if (this.countryList.length === 1) {
        this.holderDataForm.controls.nationality.setValue(this.countryList[0].id);
        this.holderDataForm.controls.birthCountry.setValue(this.countryList[0].id);
      }
      this.isCountryLoading = false;
      this.changeLoadingState();
    });

    this.isRelationHolderLoading = true;
    this.combosStore.relationHolderList$.subscribe((valor: CommonDataDTO[]) => {
      this.relationHolderList = valor;
      if (this.relationHolderList.length === 1) {
        this.holderDataForm.controls.relationHolder.setValue(this.relationHolderList[0].id);
      }
      this.isRelationHolderLoading = false;
      this.changeLoadingState();
    });

    this.emitStatusForm();
  }

  ngAfterViewInit(): void {
    if (this.mode === REQUEST_MODE_VIEW) {
      if (this.state.id !== PENDIENTES_DE_DATOS) {
        this.holderDataForm.disable();
      }
      this.setValuesToForm();
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
    }

    this.requestStore.videoSelfingID.subscribe((value) => {
      if (value === undefined || value === null || value === 'N' || value === '' || this.isDisableVSByEstablishment) {
        this.showVideoSelfing = false;
        this.holderDataForm.removeControl('checkVideoSelfing');
        this.requestStore.setvalueCheckVideoSelfing(false);
        if (value === 'N') {
          this.isDisableVSByEstablishment = true; //VS is diabled and no revaluated
        }
      } else if (value === 'S') {
        this.showVideoSelfing = true;
        this.holderDataForm.addControl('checkVideoSelfing', new FormControl('', [Validators.required]));
        this.holderDataForm.controls.checkVideoSelfing.disable();
        this.checked = true;
        this.requestStore.setvalueCheckVideoSelfing(true);
      } else if (value === 'U') {
        this.showVideoSelfing = true;
        this.holderDataForm.addControl('checkVideoSelfing', new FormControl('', [Validators.required]));
        this.holderDataForm.controls.checkVideoSelfing.enable();
        this.checked = true;
        this.requestStore.setvalueCheckVideoSelfing(true);
      } else if (value === 'O') {
        if (
          this.interviniente == null &&
          (this.requestStore.listaFormulariosAutos[CONTACT_DATA]?.controls.noemail?.value == true ||
            this.requestStore.listaFormulariosAutos[CONTACT_DATA]?.controls.nophone?.value == true)
        ) {
          this.showVideoSelfing = true;
          this.holderDataForm.addControl('checkVideoSelfing', new FormControl(''));
          this.holderDataForm.controls.checkVideoSelfing.setValidators(null);
          this.holderDataForm.controls.checkVideoSelfing.disable();
          this.checked = false;
          this.requestStore.setvalueCheckVideoSelfing(false);
        } else {
          this.showVideoSelfing = true;
          this.holderDataForm.addControl('checkVideoSelfing', new FormControl(''));
          this.holderDataForm.controls.checkVideoSelfing.setValidators(null);
          this.holderDataForm.controls.checkVideoSelfing.enable();
          this.checked = false;
          this.requestStore.setvalueCheckVideoSelfing(false);
        }
      } else if (value === 'X') {
        this.showVideoSelfing = true;
        this.holderDataForm.addControl('checkVideoSelfing', new FormControl('', [Validators.required]));
        this.holderDataForm.controls.checkVideoSelfing.enable();
        this.checked = false;
        this.requestStore.setvalueCheckVideoSelfing(false);
      } else if (value === 'IMAX') {
        this.holderDataForm.addControl('checkVideoSelfing', new FormControl(''));
        this.checked = false;
        this.holderDataForm.controls.checkVideoSelfing.disable();
        this.showVideoSelfing = true;
        this.requestStore.setvalueCheckVideoSelfing(false);
      } else if (value === 'DISABLED' || value === 'DISABLED_X') {
        this.holderDataForm.addControl('checkVideoSelfing', new FormControl(''));
        this.checked = false;
        this.holderDataForm.controls.checkVideoSelfing.disable();
        this.showVideoSelfing = true;
        this.requestStore.setvalueCheckVideoSelfing(false);
      } else if (value === 'ENABLED') {
        this.holderDataForm.addControl('checkVideoSelfing', new FormControl(''));
        this.checked = false;
        this.holderDataForm.controls.checkVideoSelfing.enable();
        this.showVideoSelfing = true;
        this.requestStore.setvalueCheckVideoSelfing(false);
      }

      if (this.mode != REQUEST_MODE_NEW) {
        if (this.interviniente != null) {
          this.loadChangesVideoselfing();
        }
      }

      if (this.mode === REQUEST_MODE_VIEW) {
        this.holderDataForm.disable();
      }
    });
    if (this.interviniente != null) {
      this.checkVideoSelfingChange();
      this.requestStore.valueCheckVideoSelfing.subscribe((data) => {
        if (this.interviniente != null) {
          this.checkVideoSelfingChange();
        }
      });
    }
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }

    if (this.mode === REQUEST_MODE_EDIT && this.state.id !== PENDIENTES_DE_DATOS) {
      this.holderDataForm.controls.checkVideoSelfing?.disable();
    }
  }

  // check video selfing intervinientes
  loadChangesVideoselfing() {
    let videoSelfingID = this.requestStore.getVideoSelfingID();
    let valueVideoSelfing = this.requestStore.getvalueCheckVideoSelfing();
    if (videoSelfingID && videoSelfingID != 'N' && videoSelfingID != '') {
      this.holderDataForm.addControl('checkVideoSelfing', new FormControl(''));
      if (valueVideoSelfing) {
        this.holderDataForm.controls.checkVideoSelfing.disable();
        this.checked = true;
        this.showVideoSelfing = true;
      } else {
        this.holderDataForm.controls.checkVideoSelfing.disable();
        this.checked = false;
        this.showVideoSelfing = true;
      }
    } else {
      this.showVideoSelfing = false;
      this.checked = false;
      this.holderDataForm.removeControl('checkVideoSelfing');
    }

    if (this.mode === REQUEST_MODE_VIEW) {
      this.holderDataForm.controls.checkVideoSelfing?.disable();
    }
  }

  ngOnDestroy(): void {
    if (!this.interviniente) this.requestStore.setDNIHolder(null);
    if (this.interviniente) this.requestStore.setDniListIntervinients(null, -1);
    this.interviniente = null;
  }

  private emitStatusForm() {
    if (this.interviniente) {
      switch (this.interviniente.id) {
        case 1:
          this.changeContinueStatus.emit({ form: <FormGroup>this.holderDataForm, id: INTERVINIENTE_1_HOLDER_DATA });
          break;
        case 2:
          this.changeContinueStatus.emit({ form: <FormGroup>this.holderDataForm, id: INTERVINIENTE_2_HOLDER_DATA });
          break;
        case 3:
          this.changeContinueStatus.emit({ form: <FormGroup>this.holderDataForm, id: INTERVINIENTE_3_HOLDER_DATA });
          break;
        case 4:
          this.changeContinueStatus.emit({ form: <FormGroup>this.holderDataForm, id: INTERVINIENTE_4_HOLDER_DATA });
          break;
        default:
          console.error('Interviniente Not found!');
      }
    } else {
      this.changeContinueStatus.emit({ form: <FormGroup>this.holderDataForm, id: HOLDER_DATA });
    }
  }

  //deshabilitar campo domiciliacion titular para intervinientes
  onChangeHolderAccount(event: Event) {
    if (this.holderDataForm.controls.holderAccount.value === 'A') {
      this.disabledOwnershipCombo.emit({ value: true, id: this.interviniente.id });
    } else {
      this.disabledOwnershipCombo.emit({ value: false, id: this.interviniente.id });
    }
  }

  addNacionality(): any {
    console.log('add nacionality', this.holderDataForm.controls.nifNie);
    if (this.holderDataForm.controls.nifNie.valid) {
      if (this.customValidators.isSpanishNIF(this.holderDataForm.controls.nifNie.value)) {
        this.holderDataForm.controls.nationality.setValue('ES');
        this.holderDataForm.controls.nationality.disable();
      } else {
        this.holderDataForm.controls.nationality.setValue('');
        this.holderDataForm.controls.nationality.enable();
      }
    } else {
      this.holderDataForm.controls.nationality.setValue('');
      this.holderDataForm.controls.nationality.enable();
    }
  }

  public validateDuplicatedDni() {
    //Borrar si había un valor antes
    if (this.interviniente) this.requestStore.setDniListIntervinients('', this.interviniente.id);

    if (this.requestStore.chekDuplicatedDNI(this.holderDataForm.controls.nifNie.value)) {
      console.log('DNI duplicado');

      const dialogConfig = new MatDialogConfig();
      //TODO Literales
      dialogConfig.data = {
        text: this.translate.instant('dialog.dni.repeated.error'),
        icon: undefined,
        title: this.translate.instant('dialog.dni.repeated.title'),
        buttonCancel: false,
      };

      this.dialog.open(ResponseDialogComponent, dialogConfig);

      this.holderDataForm.controls.nifNie.setValue('');
    } else {
      //save dni for validations
      if (!this.interviniente) this.requestStore.setDNIHolder(this.holderDataForm.controls.nifNie.value);
      if (this.interviniente)
        this.requestStore.setDniListIntervinients(this.holderDataForm.controls.nifNie.value, this.interviniente.id);
    }
  }

  public onChangeNacionalityHolder(idCountry: any) {
    const dialogConfig = new MatDialogConfig();

    if (this.countryList.find((country) => country.id === idCountry)?.operationRestricted == 'SI') {
      dialogConfig.data = {
        text: this.translate.instant('request.error.riskCountry'),
        icon: 'icon-ic_warning',
      };

      this.dialog.open(ResponseDialogComponent, dialogConfig);

      this.holderDataForm.controls.nationality.setValue('');
    }
  }

  validateAvalista() {
    console.log('validateAvalista - init', this.holderDataForm.controls.holderAccount);
    this.holderDataForm.controls.holderAccount.valueChanges.subscribe((selectedValue) => {
      console.log('validateAvalista - valuechanges', selectedValue);
      if (selectedValue === 'A') {
        let currentNumAvalistas: number = 0;
        for (let intervinientForm of intervinientesHolderData) {
          if (this.requestStore.listaFormulariosAutos[intervinientForm]?.controls.holderAccount.value === 'A') {
            currentNumAvalistas++;
            if (currentNumAvalistas > 3) {
              console.log('AVALISTA > 3');
              this.holderDataForm.controls.holderAccount.setErrors({ avalistaError: true });
              break;
            }
          }
        }
      } else {
        this.holderDataForm.controls.holderAccount.setErrors(null);
      }
    });
  }

  setValuesToForm() {
    if (this.request) {
      if (this.request.typeCoHolder && this.request.relationHolder) {
        this.holderDataForm.controls.relationHolder.setValue(this.request.relationHolder);
        this.holderDataForm.controls.holderAccount.setValue(this.request.typeCoHolder);
        this.onChangeHolderAccount(null);
      }

      let expirationDateFormated = this.request.expirationDate?.split('/');
      let birthDateFormated = this.request.birthDate?.split('/');
      this.holderDataForm.controls.gender.setValue(this.request.sex);
      this.holderDataForm.controls.nifNie.setValue(this.request.documentId);

      //save dni for validations
      if (!this.interviniente) this.requestStore.setDNIHolder(this.request.documentId);
      if (this.interviniente) this.requestStore.setDniListIntervinients(this.request.documentId, this.interviniente.id);

      if (this.customValidators.isSpanishNIF(this.request.documentId)) {
        this.holderDataForm.controls.nationality.disable();
      }

      this.holderDataForm.controls.nifNieExpiration.setValue(
        expirationDateFormated
          ? new Date(expirationDateFormated[2], expirationDateFormated[1] - 1, expirationDateFormated[0])
          : ''
      );
      this.holderDataForm.controls.nifNieExpiration.markAsDirty();
      this.holderDataForm.controls.name.setValue(this.request.name);
      this.holderDataForm.controls.surname1.setValue(this.request.surname);
      this.holderDataForm.controls.surname2.setValue(this.request.secondSurname);
      this.holderDataForm.controls.birthDate.setValue(
        birthDateFormated ? new Date(birthDateFormated[2], birthDateFormated[1] - 1, birthDateFormated[0]) : ''
      );
      this.holderDataForm.controls.birthDate.markAsDirty();
      this.holderDataForm.controls.nationality.setValue(this.request.nationality);
      this.holderDataForm.controls.birthCountry.setValue(this.request.countryBirth);
      this.holderDataForm.controls.civilStatus.setValue(this.request.civilStatus);

      this.requestStore.setVideoSelfingID(this.requestsGetDataStore.getRequestDigitalID());

      this.holderDataForm.markAllAsTouched();
    }
  }

  changeLoadingState() {
    if (
      !this.isGenderLoading &&
      !this.isCountryLoading &&
      !this.isCivilStatusLoading &&
      !this.isCivilStatusLoading &&
      !this.isRelationHolderLoading
    ) {
      this.isFinishedLoading.emit({ formID: HOLDER_DATA, value: true });
    } else {
      this.isFinishedLoading.emit({ formID: HOLDER_DATA, value: false });
    }
  }

  lettersOnly(event: any): boolean {
    if (event.type === 'paste') {
      const pastedText = event.clipboardData.getData('text');
      let containStrangeCharacter = false;
      for (let i = 0; i < pastedText.length && !containStrangeCharacter; i++) {
        let charCode = pastedText.charCodeAt(i);
        if (!this.customValidators.lettersOnly(charCode)) {
          containStrangeCharacter = true;
        }
      }
      if (containStrangeCharacter) {
        return false;
      } else {
        return true;
      }
    } else {
      return this.customValidators.lettersOnly(event.which ? event.which : event.keyCode);
    }
  }

  setVideoSelfingChange() {
    this.touchVS = true;
    let isVideoselfing = this.requestStore.getVideoSelfingID();

    if (isVideoselfing == 'O' && this.checked) {
      this.requestStore.setVideoSelfingID('U');
    } else if (isVideoselfing == 'O' && !this.checked) {
      this.requestStore.setVideoSelfingID('X');
    } else if (isVideoselfing == 'S' && this.checked) {
      this.requestStore.setVideoSelfingID('S');
    } else if (isVideoselfing == 'U' && !this.checked) {
      this.requestStore.setVideoSelfingID('X');
    } else if (isVideoselfing == 'X' && this.checked) {
      this.requestStore.setVideoSelfingID('U');
    } else if (isVideoselfing == 'U' && this.checked) {
      this.requestStore.setVideoSelfingID('U');
    } else if (isVideoselfing == 'ENABLED' && !this.checked) {
      this.requestStore.setVideoSelfingID('O');
    } else if (isVideoselfing == 'ENABLED' && this.checked) {
      this.requestStore.setVideoSelfingID('U');
    } else if (this.checked) {
      this.requestStore.setVideoSelfingID('U');
    } else {
      this.requestStore.setVideoSelfingID('X');
    }
  }

  checkVideoSelfingChange() {
    let valueVideoSelfing = this.requestStore.getvalueCheckVideoSelfing();
    let valueVideoSelfingID = this.requestStore.getVideoSelfingID();
    if (valueVideoSelfing) {
      this.showVideoSelfing = true;
      this.holderDataForm.addControl('checkVideoSelfing', new FormControl(''));
      this.holderDataForm.controls.checkVideoSelfing.disable();
      this.checked = true;
    } else {
      if (valueVideoSelfingID != 'N' && valueVideoSelfingID != '' && valueVideoSelfingID != null) {
        this.showVideoSelfing = true;
        this.holderDataForm.addControl('checkVideoSelfing', new FormControl(''));
        this.holderDataForm.controls.checkVideoSelfing.disable();
        this.checked = false;
      }
    }
  }

  // Desarrollo CTI

  // checkNameAndSurname(value: any, element: any) {
  //   const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
  //   let inputValue = typeof value === 'string' ? value : value?.target.value;

  //   const valueWithoutSpaces = inputValue.trim();
  //   this.holderDataForm.controls[inputForm].setValue(valueWithoutSpaces);

  //   if (valueWithoutSpaces.length > 0) {
  //     if (!this.customValidators.validateNameAndSurname(valueWithoutSpaces)) {
  //       this.holderDataForm.controls[inputForm].setErrors({ incorrect: true });
  //     } else {
  //       let name = this.holderDataForm.controls.name.value;
  //       let surname1 = this.holderDataForm.controls.surname1.value;
  //       let surname2 = this.holderDataForm.controls.surname2.value;

  //       if (name.trim().length > 0 && surname1.trim().length > 0 && surname2.trim().length > 0) {
  //         this.geocodeStore
  //           .normalizarNombre(name, surname1, surname2)
  //           .then(
  //             (data: any) => {
  //               this.holderDataForm.controls[inputForm].setErrors(null);
  //               this.holderDataForm.controls.name.setValue(data?.nombre);
  //               this.holderDataForm.controls.surname1.setValue(data?.apellido1);
  //               this.holderDataForm.controls.surname2.setValue(data?.apellido2);
  //             },
  //             (error) => {
  //               this.holderDataForm.controls[inputForm].setErrors({ incorrect: true });
  //               console.log(error);
  //             }
  //           )
  //           .finally(() => {
  //             this.isFinishedLoading.emit({ formID: HOLDER_DATA, value: true });
  //           });
  //       }
  //     }
  //   }
  // }

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.holderDataForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
